import * as actionTypes from "../actions/actionTypes";

const initialState = {
  isLoading: false,
};

const showLoader = () => {
  return { isLoading: true };
};

const hideLoader = () => {
  return { isLoading: false };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_SPINNER:
      return showLoader();

    case actionTypes.HIDE_SPINNER:
      return hideLoader();

    default:
      return state;
  }
};

export default reducer;
